(() => {
  const root = document.querySelector('[data-rm-wizard]');
  const openBtn = document.querySelector('[data-rm-open-form]');
  if (!root) return;

  const form = root.querySelector('form');
  const panels = [...root.querySelectorAll('[data-rm-step]')];
  const tabs = [...root.querySelectorAll('[data-rm-step-btn]')];
  const prev = root.querySelector('[data-rm-prev]');
  const next = root.querySelector('[data-rm-next]');
  const submit = root.querySelector('[data-rm-submit]');
  const formError = root.querySelector('[data-rm-form-error]');
  if (form) form.noValidate = true;
  const filesInput = root.querySelector('[data-rm-files-input]');
  const filesDrop = root.querySelector('[data-rm-files-drop]');
  const filesList = root.querySelector('[data-rm-files-list]');
  const filesLabel = root.querySelector('[data-rm-files-label]');
  const filesStatus = root.querySelector('[data-rm-files-status]');
  const filesUrls = root.querySelector('[data-rm-files-urls]');
  const platesSelect = root.querySelector('[data-rm-plates]');
  const summaryInput = root.querySelector('[data-rm-supplements-summary]');
  const centsInput = root.querySelector('[data-rm-supplements-cents]');
  const totalExtrasEl = root.querySelector('[data-rm-total-extras]');
  const totalSumEl = root.querySelector('[data-rm-total-sum]');
  const pricingEl = root.querySelector('[data-rm-pricing]');
  const variantId = Number(root.dataset.rmVariant || 0);
  const cartUrl = root.dataset.rmCart || '/cart';
  const copy = {
    drop: root.dataset.i18nDrop || '',
    selected: root.dataset.i18nSelected || '{n} fichier(s) sélectionné(s) — clique pour ajouter',
    ignored: root.dataset.i18nIgnored || 'Ignorés : ',
    remove: root.dataset.i18nRemove || 'Supprimer',
    kb: root.dataset.i18nKb || 'Ko',
    uploading: root.dataset.i18nUploading || 'Upload des fichiers en cours…',
    uploaded: root.dataset.i18nUploaded || 'Fichiers ajoutés — envoi au panier…',
    uploadFail:
      root.dataset.i18nUploadFail ||
      'Upload distant indisponible — les noms de fichiers sont joints à la commande.',
    sending: root.dataset.i18nSending || 'Envoi des fichiers…',
    adding: root.dataset.i18nAdding || 'Ajout au panier…',
  };
  const submitLabel = submit ? submit.textContent.trim() : copy.adding;

  let step = 0;
  let selectedFiles = [];
  let pricing = {
    baseCents: 0,
    moneyFormat: '{{amount}} €',
    rules: { base: {}, lam: {}, swing: {}, plates: {} },
    addons: {},
  };

  try {
    if (pricingEl) pricing = { ...pricing, ...JSON.parse(pricingEl.textContent) };
  } catch (err) {
    console.error(err);
  }

  const formatMoney = (cents) => {
    const amount = (Number(cents) / 100).toFixed(2).replace('.', ',');
    const format = pricing.moneyFormat || '{{amount}} €';
    if (format.includes('{{amount_with_comma_separator}}')) {
      return format.replace('{{amount_with_comma_separator}}', amount);
    }
    if (format.includes('{{amount}}')) {
      return format.replace('{{amount}}', amount);
    }
    return `${amount} €`;
  };

  const openForm = () => {
    root.hidden = false;
    root.classList.remove('is-collapsed');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  openBtn?.addEventListener('click', openForm);

  if (window.location.hash === `#${root.id}` || window.location.hash === '#formulaire') {
    openForm();
  }

  const show = (index) => {
    step = Math.max(0, Math.min(panels.length - 1, index));
    panels.forEach((panel, i) => {
      const active = i === step;
      panel.classList.toggle('is-active', active);
      if (active) panel.removeAttribute('hidden');
      else panel.setAttribute('hidden', '');
    });
    tabs.forEach((tab, i) => {
      if (i === step) tab.setAttribute('aria-current', 'step');
      else tab.removeAttribute('aria-current');
    });
    if (prev) prev.style.visibility = step === 0 ? 'hidden' : 'visible';
    if (next && submit) {
      const last = step === panels.length - 1;
      next.hidden = last;
      submit.hidden = !last;
    }
  };

  const showFormError = (message) => {
    if (!formError) return;
    formError.hidden = false;
    formError.textContent = message;
  };

  const clearFormError = () => {
    if (!formError) return;
    formError.hidden = true;
    formError.textContent = '';
  };

  const fieldLabel = (el) => {
    const id = el.id;
    const label = id ? form.querySelector(`label[for="${CSS.escape(id)}"]`) : null;
    const text = (label?.textContent || el.getAttribute('aria-label') || 'Ce champ')
      .replace(/\*/g, '')
      .trim();
    return text || 'Ce champ';
  };

  const invalidInPanel = (panel) => {
    if (!panel) return null;
    const fields = [...panel.querySelectorAll('input, select, textarea')];
    return (
      fields.find((el) => {
        if (el.disabled || el.type === 'hidden' || el.type === 'file') return false;
        if (!el.required) return false;
        if (el.type === 'radio' || el.type === 'checkbox') {
          const group = panel.querySelectorAll(`[name="${CSS.escape(el.name)}"]`);
          return ![...group].some((item) => item.checked);
        }
        return !String(el.value || '').trim();
      }) || null
    );
  };

  const revealInvalid = (el) => {
    const panel = el.closest('[data-rm-step]');
    if (panel) show(Number(panel.dataset.rmStep || 0));
    showFormError(`${fieldLabel(el)} est obligatoire.`);
    requestAnimationFrame(() => {
      el.focus({ preventScroll: false });
      if (typeof el.reportValidity === 'function') el.reportValidity();
    });
  };

  const canLeaveStep = (index) => {
    const bad = invalidInPanel(panels[index]);
    if (!bad) {
      clearFormError();
      return true;
    }
    revealInvalid(bad);
    return false;
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = Number(tab.dataset.rmStepBtn);
      if (target > step) {
        for (let i = step; i < target; i += 1) {
          if (!canLeaveStep(i)) return;
        }
      }
      clearFormError();
      show(target);
    });
  });
  prev?.addEventListener('click', () => {
    clearFormError();
    show(step - 1);
  });
  next?.addEventListener('click', () => {
    if (!canLeaveStep(step)) return;
    show(step + 1);
  });

  const getChoice = (group) => {
    const input = root.querySelector(`[data-rm-choice-input="${group}"]`);
    return input?.value || '';
  };

  const selectChoice = (group, value) => {
    root.querySelectorAll(`[data-rm-choice="${group}"]`).forEach((el) => {
      const on = el.dataset.value === value;
      el.classList.toggle('is-selected', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    const input = root.querySelector(`[data-rm-choice-input="${group}"]`);
    if (input) input.value = value;
    updatePricing();
  };

  const computeExtras = () => {
    const base = getChoice('base');
    const lam = getChoice('lam');
    const swing = getChoice('swing');
    const rush = getChoice('rush');
    const plates = platesSelect?.value || 'Non';
    const lines = [];
    let cents = 0;

    const add = (label, key, ruleGroup) => {
      const amount = Number(pricing.rules?.[ruleGroup]?.[key] || 0);
      if (!amount) return;
      cents += amount;
      lines.push(`${label} +${formatMoney(amount)}`);
    };

    add(base, base, 'base');
    if (swing !== 'Bras oscillant transparent') {
      add(lam, lam, 'lam');
    }
    add(swing, swing, 'swing');
    if (plates !== 'Non') {
      add(`${plates} mini-plaques`, plates, 'plates');
    }
    add(rush, rush, 'rush');

    return { cents, lines, base, lam, swing, rush, plates };
  };

  const updatePricing = () => {
    const { cents, lines } = computeExtras();
    if (summaryInput) summaryInput.value = lines.length ? lines.join(' · ') : 'Aucun';
    if (centsInput) centsInput.value = String(cents);
    if (totalExtrasEl) totalExtrasEl.textContent = `+${formatMoney(cents)}`;
    if (totalSumEl) totalSumEl.textContent = formatMoney(Number(pricing.baseCents || 0) + cents);
  };

  root.querySelectorAll('[data-rm-choice]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const group = btn.dataset.rmChoice;
      const value = btn.dataset.value || '';
      selectChoice(group, value);

      if (group === 'swing' && value === 'Bras oscillant transparent') {
        selectChoice('lam', 'Brillante');
      }
    });
  });

  platesSelect?.addEventListener('change', updatePricing);

  const ALLOWED = /\.(pdf|png|jpe?g|svg|ai)$/i;
  const MAX_BYTES = 10 * 1024 * 1024;

  const setStatus = (message, visible = true) => {
    if (!filesStatus) return;
    filesStatus.hidden = !visible;
    filesStatus.textContent = message || '';
  };

  const renderFiles = () => {
    if (!filesList) return;
    filesList.innerHTML = '';
    if (!selectedFiles.length) {
      filesList.hidden = true;
      if (filesLabel) {
        filesLabel.innerHTML =
          copy.drop ||
          'Glisse tes fichiers ici ou clique pour choisir<br>PDF, PNG, JPG, SVG, AI — max 10 Mo / fichier';
      }
      return;
    }
    filesList.hidden = false;
    if (filesLabel) {
      filesLabel.textContent = copy.selected.replace('{n}', String(selectedFiles.length));
    }
    selectedFiles.forEach((file, index) => {
      const li = document.createElement('li');
      li.className = 'rm-files-list__item';

      const name = document.createElement('span');
      name.className = 'rm-files-list__name';
      name.textContent = `${file.name} (${Math.round(file.size / 1024)} ${copy.kb})`;

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'rm-files-list__remove';
      remove.setAttribute('aria-label', `${copy.remove} ${file.name}`);
      remove.textContent = '×';
      remove.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        selectedFiles = selectedFiles.filter((_, i) => i !== index);
        renderFiles();
        if (!selectedFiles.length) setStatus('', false);
      });

      li.append(name, remove);
      filesList.appendChild(li);
    });
  };

  const takeFiles = (fileList) => {
    const incoming = [...(fileList || [])];
    if (!incoming.length) return;

    const accepted = [];
    const rejected = [];

    incoming.forEach((file) => {
      if (!ALLOWED.test(file.name)) {
        rejected.push(`${file.name} (format)`);
        return;
      }
      if (file.size > MAX_BYTES) {
        rejected.push(`${file.name} (>10 Mo)`);
        return;
      }
      accepted.push(file);
    });

    const byName = new Map(selectedFiles.map((f) => [f.name, f]));
    accepted.forEach((f) => byName.set(f.name, f));
    selectedFiles = [...byName.values()];

    if (rejected.length) {
      setStatus(`${copy.ignored}${rejected.join(', ')}`);
    } else {
      setStatus('', false);
    }
    renderFiles();
  };

  filesDrop?.addEventListener('click', (e) => {
    if (e.target === filesInput) return;
    e.preventDefault();
    filesInput?.click();
  });

  filesDrop?.addEventListener('dragover', (e) => {
    e.preventDefault();
    filesDrop.classList.add('is-dragover');
  });

  filesDrop?.addEventListener('dragleave', () => {
    filesDrop.classList.remove('is-dragover');
  });

  filesDrop?.addEventListener('drop', (e) => {
    e.preventDefault();
    filesDrop.classList.remove('is-dragover');
    takeFiles(e.dataTransfer?.files);
  });

  filesInput?.addEventListener('change', () => {
    takeFiles(filesInput.files);
    filesInput.value = '';
  });

  const prepareFile = async (file) => {
    if (!file.type.startsWith('image/') || file.size < 1_800_000) return file;
    try {
      const bitmap = await createImageBitmap(file);
      const max = 2000;
      const scale = Math.min(1, max / Math.max(bitmap.width, bitmap.height));
      const w = Math.max(1, Math.round(bitmap.width * scale));
      const h = Math.max(1, Math.round(bitmap.height * scale));
      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      canvas.getContext('2d').drawImage(bitmap, 0, 0, w, h);
      bitmap.close?.();
      const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.85));
      if (!blob || blob.size >= file.size) return file;
      const base = file.name.replace(/\.[^.]+$/, '') || 'image';
      return new File([blob], `${base}.jpg`, { type: 'image/jpeg', lastModified: Date.now() });
    } catch {
      return file;
    }
  };

  const uploadToGofile = async (file) => {
    const serversRes = await fetch('https://api.gofile.io/servers');
    if (!serversRes.ok) throw new Error('gofile servers');
    const serversBody = await serversRes.json();
    const server = serversBody?.data?.servers?.[0]?.name;
    if (!server) throw new Error('gofile server missing');
    const fd = new FormData();
    fd.append('file', file);
    const res = await fetch(`https://${server}.gofile.io/contents/uploadfile`, {
      method: 'POST',
      body: fd,
    });
    if (!res.ok) throw new Error(`gofile ${res.status}`);
    const body = await res.json();
    const page = body?.data?.downloadPage;
    if (!page || !/^https?:\/\//i.test(page)) throw new Error('gofile url');
    return page;
  };

  const uploadToLitterbox = async (file) => {
    const fd = new FormData();
    fd.append('reqtype', 'fileupload');
    fd.append('time', '72h');
    fd.append('fileToUpload', file);
    const res = await fetch('https://litterbox.catbox.moe/resources/internals/api.php', {
      method: 'POST',
      body: fd,
    });
    if (!res.ok) throw new Error(`litterbox ${res.status}`);
    const url = (await res.text()).trim();
    if (!/^https?:\/\//i.test(url)) throw new Error('litterbox url');
    return url;
  };

  const uploadFile = async (file) => {
    const prepared = await prepareFile(file);
    const errors = [];
    for (const attempt of [uploadToGofile, uploadToLitterbox]) {
      try {
        return await attempt(prepared);
      } catch (err) {
        errors.push(err?.message || String(err));
      }
    }
    throw new Error(
      `Impossible d’envoyer la photo « ${file.name} ». Réessaie ou réduis la taille. (${errors.join(' / ')})`
    );
  };

  const collectProperties = () => {
    const props = {};
    form.querySelectorAll('[name^="properties["]').forEach((el) => {
      const match = el.name.match(/^properties\[(.+)\]$/);
      if (!match) return;
      props[match[1]] = el.value;
    });
    return props;
  };

  const buildAddonItems = (extras) => {
    const items = [];
    const map = pricing.addons || {};
    const push = (key) => {
      const id = map[key];
      if (!id) return;
      items.push({
        id: Number(id),
        quantity: 1,
        properties: { Pour: 'Kit déco', Option: key },
      });
    };

    if (extras.base === 'Chrome' || extras.base === 'Holographique') push(extras.base);
    if (
      extras.swing !== 'Bras oscillant transparent' &&
      (extras.lam === 'Mat' || extras.lam === 'Paillettes')
    ) {
      push(extras.lam);
    }
    if (extras.swing === 'Bras oscillant transparent') push(extras.swing);
    if (extras.plates !== 'Non') push(extras.plates);
    if (extras.rush === 'Délai express') push(extras.rush);
    return items;
  };

  const cartRoot = () => {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : `${root}/`;
  };

  const postCartItems = async (items) => {
    const res = await fetch(`${cartRoot()}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    const body = await res.json().catch(() => ({}));
    if (!res.ok) {
      throw new Error(body.description || body.message || `Erreur panier (${res.status})`);
    }
    return body;
  };

  const addToCart = async () => {
    updatePricing();
    if (!variantId) {
      throw new Error('Variante produit introuvable');
    }
    const extras = computeExtras();
    const properties = collectProperties();
    const main = { id: Number(variantId), quantity: 1, properties };
    const addons = buildAddonItems(extras).filter((item) => item.id > 0);

    // Essai groupé, sinon produit seul (évite un échec total si un supplément est mal lié)
    try {
      await postCartItems([main, ...addons]);
    } catch (err) {
      console.warn('Ajout groupé échoué, retry produit seul', err);
      await postCartItems([main]);
      for (const addon of addons) {
        try {
          await postCartItems([addon]);
        } catch (addonErr) {
          console.warn('Supplément non ajouté', addon, addonErr);
        }
      }
    }
    window.location.assign(cartUrl || `${cartRoot()}cart`);
  };

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    event.stopPropagation();

    for (let i = 0; i < panels.length; i += 1) {
      const invalid = invalidInPanel(panels[i]);
      if (invalid) {
        revealInvalid(invalid);
        return;
      }
    }
    clearFormError();

    if (submit) {
      submit.disabled = true;
      submit.textContent = selectedFiles.length ? copy.sending : copy.adding;
    }

    try {
      if (selectedFiles.length && filesUrls && filesUrls.dataset.ready !== '1') {
        setStatus(copy.uploading);
        const urls = [];
        for (let i = 0; i < selectedFiles.length; i += 1) {
          const file = selectedFiles[i];
          setStatus(`${copy.uploading} ${i + 1}/${selectedFiles.length}`);
          const url = await uploadFile(file);
          urls.push(`${file.name}: ${url}`);
        }
        filesUrls.value = urls.join('\n');
        filesUrls.dataset.ready = '1';
        setStatus(copy.uploaded);
      }

      if (submit) submit.textContent = copy.adding;
      await addToCart();
    } catch (err) {
      console.error(err);
      setStatus(err.message || 'Erreur panier');
      window.alert(err.message || 'Impossible d’ajouter au panier');
      if (submit) {
        submit.disabled = false;
        submit.textContent = submitLabel;
      }
    }
  });

  updatePricing();
  show(0);
})();
